<template>
        <div>
            <h3 class="editor-header" v-if="!this.isAddEquipmentMode">
                {{ $t('portal.portal')  }}
            </h3>
            <div class="row">
                <location-deviation v-if="this.isAddEquipmentMode" :location-deviation="item.location_deviation"/>
            </div>
            <div class="row">
                <div v-if="!this.isAddEquipmentMode">
                    <div class="col-sm-6">
                        <span class="span-title">{{ $t('common.id') }}</span>
                        <span class="item-detail-text">{{ item.external_system_id }}</span>
                    </div>
                    <div class="col-sm-6">
                        <road-addess-view :road-number="item.road_num" :section-number="item.road_sec" :distance="item.distance" :show-street-name="false"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('portal.type') }}</span>
                        <select
                            class="form-select form-select-sm"
                            v-model="item.type"
                            :class="{ 'is-valid': validateIsNumber(item.type), 'is-invalid': !validateIsNumber(item.type) }"
                        >
                            <option
                                v-for="option in getPortalTypes()"
                                :key="option.value"
                                :value="option.value"
                            >
                                {{ option.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('portal.add_type') }}</span>
                        <select
                            class="form-select form-select-sm"
                            v-model="item.additional_type"
                        >
                            <option
                                v-for="option in getPortalAdditionalTypes()"
                                :key="option.value"
                                :value="option.value"
                            >
                                {{ option.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-sm-4">
                        <condition-selector v-model="item.condition" :required="true"/>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('portal.foundation') }}</span>
                        <select
                            class="form-select form-select-sm"
                            v-model="item.foundation"
                        >
                            <option
                                v-for="option in getPortalFoundations()"
                                :key="option.value"
                                :value="option.value"
                            >
                                {{ option.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('portal.structure') }}</span>
                        <select
                            class="form-select form-select-sm"
                            v-model="item.structure"
                        >
                            <option
                                v-for="option in getPortalStructures()"
                                :key="option.value"
                                :value="option.value"
                            >
                                {{ option.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('portal.code') }}</span>
                        <input
                            id="height"
                            type="text"
                            class="form-control form-control-sm"
                            v-model="item.code"
                            min="1"
                        />
                    </div>
                </div>
                <div class="row px-2">
                    <location-details
                        v-if="!this.isAddEquipmentMode"
                        :lane-data="item.location_specification.lane"
                        :side-data="item.location_specification.side"
                        :track-data="item.location_specification.tracks"
                    />
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('portal.length') }}</span>
                        <input
                            id="length"
                            v-model="item.length"
                            type="number"
                            class="form-control form-control-sm"
                        />
                    </div>
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('portal.lower_edge_height') }}</span>
                        <input
                            id="lower_edge_height"
                            v-model="item.lower_edge_height"
                            type="number"
                            class="form-control form-control-sm"
                        />
                    </div>
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('portal.pilar_height') }}</span>
                        <input
                            id="pilar_height_level"
                            v-model="item.pilar_height_level"
                            type="number"
                            class="form-control form-control-sm"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('portal.area') }}</span>
                        <input
                            id="area"
                            v-model="item.area"
                            type="number"
                            class="form-control form-control-sm"
                        />
                    </div>
                </div>
                <div class="row" v-if="this.isAddEquipmentMode">
                    <div class="col-sm-12 nopads mt-2">
                        <h4 class="form-header nopads mt-0">{{ $t('velho_equipment.location_spesifications') }}</h4>
                        <velho-equipment-location-details-editor
                            :hideRampSelector="true"
                            :hideShoulderSelector="true"
                            :hidePlatformSelector="true"
                            :hideEdgeAreaSelector="true"
                            :hideDitchBottomSelector="true"
                            :hideDividerSelector="true"
                            :hideCenterAreaSelector="true"
                            :roadInfo="item"
                            :locationSpecification="item.location_specification"
                            :sideRequired="false"
                            :hideSideSelector="true"
                        />
                    </div>
                </div>
                <hr class="mb-0">
                <div class="row" v-if="this.isAddEquipmentMode">
                    <div class="col-sm-6 nopads mt-2">
                        <equipment-date
                            :text="$t('velho_equipment.start_date')"
                            v-model="item.created_at"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 nopads mt-2">
                        <velho-equipment-damages :items="item.equipment_damages"/>
                    </div>
                </div>
                <div class="row">
                    <equipment-actions v-if="!this.isAddEquipmentMode" ref="actions" v-model="item.actions" />
                </div>
                <div class="row">
                    <linked-equipment
                        v-if="item.linked_equipment && item.linked_equipment.length > 0"
                        :linked-equipments="item.linked_equipment"
                    />
                </div>

            </div>
            <velho-editor-buttons
                v-if="!this.isAddEquipmentMode"
                :url="extPortalUrl"
                :selected-contract="selectedContract"
                :item="item"
                :disabled="loading"
                @close="close"
                @submit="handleSubmit"
                @removalConfirmed="removalConfirmed"
            />
        <div
            v-if="loading > 0"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {mapHelper} from "@/components/mixins/MapMixin";
import {conversionModelHelper} from "@/components/mixins/ConversionMixin";
import {restApi} from "@/components/mixins/RestApiMixin";
import ConditionSelector from "@/components/velho/ConditionSelector";
import {velhoHelper} from "@/components/mixins/VelhoMixin";
import EquipmentActions from "@/components/velho/EquipmentActions";
import {portalHelper} from "@/components/mixins/PortalMixin";
import VelhoEditorButtons from "@/components/velho/VelhoEditorButtons";
import LinkedEquipment from "@/components/velho/LinkedEquipment";
import LocationDetails from "@/components/velho/LocationDetails.vue";
import LocationDeviation from "@/components/velho/LocationDeviation";
import VelhoEquipmentLocationDetailsEditor from "@/components/velho/VelhoEquipmentLocationDetailsEditor";
import VelhoEquipmentDamages from "@/components/velho/VelhoEquipmentDamages";
import RoadAddessView from "@/components/velho/RoadAddressView";
import {velhoValidationMixin} from "@/components/mixins/VelhoValidationMixin";
import EquipmentDate from "@/components/velho/EquipmentDate.vue";

export default {
    name: 'PortalEditor',
    components: {
        EquipmentDate,
        RoadAddessView,
        LocationDeviation, VelhoEquipmentLocationDetailsEditor, VelhoEquipmentDamages,
        LocationDetails, VelhoEditorButtons, EquipmentActions, ConditionSelector, LinkedEquipment},
    mixins: [mapHelper, conversionModelHelper, restApi, velhoHelper, portalHelper, velhoValidationMixin],
    props: {
        item: {
            type: Object,
            default: null
        },
        selectedContract: {
            type: Object,
            default: null
        },
        addEquipmentEditor: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isAddEquipmentMode() {
            return this.addEquipmentMode
        }
    },
    data() {
        return {
            addEquipmentMode: this.addEquipmentEditor,
            map: null,
            loading: false,
        }
    },
    methods: {
        handleSubmit: function(url, item, selectedContract, replace = false) {
            if(replace) {
                this.submitEquipmentsreplace(this.extEquipmentsReplaceUrl, [item], selectedContract)
            } else {
                this.submitEquipment(url, item, selectedContract);
            }
        },
        close: function () {
            this.$emit('close')
        },
        isValidForm: function() {
            if(!this.item) { return false }
            if(!this.validateRoadNumber(this.item.road_num)) { return false }
            if(!this.validateRoadSection(this.item.road_sec)) { return false }
            if(!this.validateRoadDistance(this.item.distance)) { return false }
            if(!this.validateIsNumber(this.item.type)) { return false }
            if(!this.validateIsNumber(this.item.condition)) { return false }
            if(!this.validateRoadTracks(this.item.location_specification.tracks)) { return false }

            return true
        }
    }
}
</script>

<style scoped>
</style>

